import { render, staticRenderFns } from "./layoutUserInfoBase.vue?vue&type=template&id=1f7ed0a2&scoped=true&"
import script from "./layoutUserInfoBase.vue?vue&type=script&lang=ts&"
export * from "./layoutUserInfoBase.vue?vue&type=script&lang=ts&"
import style0 from "./layoutUserInfoBase.vue?vue&type=style&index=0&id=1f7ed0a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7ed0a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f7ed0a2')) {
      api.createRecord('1f7ed0a2', component.options)
    } else {
      api.reload('1f7ed0a2', component.options)
    }
    module.hot.accept("./layoutUserInfoBase.vue?vue&type=template&id=1f7ed0a2&scoped=true&", function () {
      api.rerender('1f7ed0a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/layoutUserInfoBase.vue"
export default component.exports